import { Platform } from 'react-native';

import { navigate } from '../../../../routes';
import { eventBus } from '../../../../services/eventBus';
import { storage } from '../../../../services/localstorage';
import {
    delay,
    getRandomNumber
} from '../../../../utils/fn';
import { consoleLog } from '../../../../utils/log';
import {
    backupInfoProcessing,
    toLog
} from '../Backup';
import { doAutoBackup } from '../google/googleDrive';
import {
    getBackupEnabled,
    getFullBackupData,
    getProfileInfo
} from './backupData';


export const LOG_BACKUP = false;
export const LOG_RESTORE = true;

export const DEV_MODE = false;

export const BACKUP_AUTO_DELAY = DEV_MODE ? getRandomNumber(3, 15) : 10;

export const NEED_SHOW_RESTORE_SCREEN_KEY = 'needShowRestoreScreen';

const OPERATION_TYPES = {
    BACKUP: 'backup',
    RESTORE: 'restore',
};

const performBackup = async () => {
    const {
        googleCloudEnabled,
        iCloudEnabled,
    } = getBackupEnabled();
    consoleLog('Performing backup. Google Cloud enabled:', googleCloudEnabled, 'iCloud enabled:', iCloudEnabled);
    if (!googleCloudEnabled && !iCloudEnabled) {
        consoleLog('Backup is not enabled for Google Cloud or iCloud');
        return null;
    }
    try {
        let google = null;
        let iCloud = null;
        // if (googleCloudEnabled) {
        const fullData = await getFullBackupData();
        google = await doAutoBackup(fullData);
        LOG_BACKUP && consoleLog('Backup completed successfully',
            google);
        // }
        // if (iCloudEnabled && Platform.OS === 'ios') {
        //     iCloud = await startICloudBackup({
        //         onError: (error) => {
        //             throw new Error('iCloud backup failed: ' + error.message);
        //         },
        //     });
        //     LOG_BACKUP && consoleLog('Backup completed successfully',
        //         google);
        // }
        return {
            google,
            iCloud,
        };
    } catch (error) {
        consoleLog('Error during backup:',
            error);
        throw error;
    }
};

const performRestore = async (data) => {
    try {
        const {
            googleCloudEnabled,
            iCloudEnabled,
        } = getBackupEnabled();
        if (googleCloudEnabled || iCloudEnabled) {
            backupInfoProcessing.disableStartupBackup = true;
            navigate('Account',
                {
                    screen: 'Restore',
                    data,
                    googleCloudEnabled,
                    iCloudEnabled,
                });
        }
        return {
            data,
            googleCloudEnabled,
            iCloudEnabled,
        };
    } catch (error) {
        consoleLog('Error during restore:',
            error);
        throw error;
    }
};

const hasBackupData = (data) => {
    if (!data) {
        return false;
    }

    if (Array.isArray(data)) {
        return data.length > 0;
    }

    if (data.data && Array.isArray(data.data)) {
        return data.data.length > 0;
    }

    return Object.keys(data).length > 0;
};

export const checkRestore = async (data) => {
    LOG_RESTORE && toLog('checkRestore', data);
    if (Object.isGetCodeConfirmation === true) {
        Object.isGetCodeConfirmation = false;
        await setNeedShowRestoreScreen(false, data?.profileId ?? data?.me?.profileId);
        const result = await performRestore(data);
        Object.backupCreated = true;
        LOG_RESTORE && consoleLog('Restoring backup data',
            result);
    }
};

export const setNeedShowRestoreScreen = async (needShow, profileId) => {
    if (Platform.OS === 'web') {
        return;
    }

    try {

        const data = await storage.getObject(NEED_SHOW_RESTORE_SCREEN_KEY, {});
        (data ?? {})[profileId] = needShow;
        await storage.set(NEED_SHOW_RESTORE_SCREEN_KEY, data);
        return data;
    } catch (e) {
        toLog('setNeedShowRestoreScreen error', e);
        return {};
    }
};

export const isNeedShowRestoreScreen = async (profileId) => {
    if (Platform.OS === 'web') {
        return false;
    }
    try {
        const data = await storage.getObject(NEED_SHOW_RESTORE_SCREEN_KEY, {});
        const needShow = data?.[profileId];
        return needShow === true || needShow === undefined;
    } catch (e) {
        toLog('isNeedShowRestoreScreen error', e);
        return true;
    }
};

export const checkStartupBackupRestore = async (data = []) => {
    if (Platform.OS === 'web') {
        return;
    }
    const operationType = hasBackupData(data) ? OPERATION_TYPES.BACKUP : OPERATION_TYPES.RESTORE;
    const { info } = getProfileInfo();
    (LOG_BACKUP || LOG_RESTORE) && toLog('checkStartupBackupRestore', {
        data,
        info,
        operationType,
        backupInfoProcessing,
    });

    try {
        if (backupInfoProcessing.disableBackup || backupInfoProcessing.disableStartupBackup) {
            return {
                operation: operationType,
                success: false,
                result: null,
            };
        }
        await delay(BACKUP_AUTO_DELAY * 1000);

        let result;

        const needRestore = await isNeedShowRestoreScreen(data?.profileId);
        if (operationType === OPERATION_TYPES.BACKUP) {
            const disable = backupInfoProcessing.disableBackup;
            if (disable) {
                return {
                    operation: operationType,
                    success: false,
                    result: null,
                };
            }
            if (Object.isGetCodeConfirmation === true && needRestore) {
                eventBus.emit('RESTORE', {
                    data,
                    info,
                });
            } else {
                if (!Object.backupCreated) {
                    Object.backupCreated = true;
                    result = await performBackup();
                }
            }
        } else {
            if (!needRestore) {
                return {
                    operation: operationType,
                    success: false,
                    result: null,
                };
            }
            if ((!info?.birthday || !info?.name || !info?.me?.subName) && (!data?.me?.subName)) {
                //
            } else {
                eventBus.emit('RESTORE',
                    data);
            }
        }

        return {
            operation: operationType,
            success: true,
            result,
        };

    } catch (error) {
        consoleLog(`Error in ${operationType} operation:`,
            error);
        throw new Error(`Failed to ${operationType}: ${error.message}`);
    }
};
